// src/store/actions/commentActions.ts
import { createAction } from '@reduxjs/toolkit';
import { CommentItem } from '../../types/commentTypes';

export const fetchCommentsRequest = createAction<number>('comment/fetchRequest');
export const fetchCommentsSuccess = createAction<CommentItem[]>('comment/fetchSuccess');
export const fetchCommentsFailure = createAction<string>('comment/fetchFailure');

export const createCommentRequest = createAction<{ boardId: number; userId: number; content: string }>('comment/createRequest');
export const createCommentSuccess = createAction<CommentItem>('comment/createSuccess');
export const createCommentFailure = createAction<string>('comment/createFailure');

export const deleteCommentRequest = createAction<{ commentId: number; userId: number }>('comment/deleteRequest');
export const deleteCommentSuccess = createAction<number>('comment/deleteSuccess');
export const deleteCommentFailure = createAction<string>('comment/deleteFailure');
